export default {
    ru: {
        req: 'обяз',
        until: 'до',
        amount_send: 'Сумма и валюта отправления',
        currency_send: 'Валюта отправления',
        currency_receive: 'Валюта получения',
        amount: 'Сумма',
        sender_name: 'Отправитель (вы)',
        name_send: `Имя и фамилия получателя`,
        name_placeholder: 'Ivan Petrov',
        phone_send: `Номер телефона получателя`,
        card_send: `Номер карты получателя`,
        account_send: `Номер счета получателя`,
        telegram: 'Телеграм ник',
        telegram_placeholder: "Ваш никнейм в телеграме",
        // Единый ярлык способа оплаты
        payment_method: `Выберите удобный способ оплаты`,
        choose_senders_bank: 'Выберите удобный способ отправки',
        choose_recipients_bank: 'Выберите удобный способ получения',
        choose_senders_bank_title: 'Вы можете выбрать любой банк, на который вам удобно отправить перевод',
        bank_list: `Укажите способ получения`,
        pay_sys_comission: 'Комиссия платежной системы',
        bank_comission: 'Комиссия банка',
        service_comission: 'Комиссия сервиса',
        use_cashback: 'Использовать кешбэк',
        cashback_writeoff: 'Списать с партнерского кошелька',
        guaranteed_rate: 'Обменный курс',
        exchange_rate: 'Биржевой курс',
        guaranteed_rate_total: 'Итоговый обменный курс',
        guaranteed_time: '15 минут',
        time_title: 'Примерное время перевода',
        limits_title: 'Лимиты за перевод',
        limits_text: 'Данный курс не связан с центральным банком и расчитывается на основе данных торговых бирж.',
        amount_receive: 'Сумма и валюта к получению',
        select_currency: 'Выберите валюту',
        translation_time: 'Время перевода: 15 минут',
        recipient_list: 'Список получателей',
        choose_recipient: 'Выберите получателя',
        create_recipient: 'Создать нового получателя',
        select_recipient: 'Выберите получателя',
        show_description: 'Добавить описание',
        hide_description: 'Скрыть описание',
        button: 'Создать перевод',
        // Сохраняем оба ключа для обратной совместимости
        button_create: 'Пополнить счет',
        button_bill: 'Оплатить счет',
        before: 'Предварительно необходимо пройти регистрацию',
        first_transfer: 'Вам доступен тестовый перевод на',
        do_first_transfer: 'Сделать тестовый перевод',
        first_transfer_title: 'Что такое тестовый перевод?',
        first_transfer_text: 'В первый раз вы можете перевести всего 500 рублей для того, чтобы убедиться в качестве нашего сервиса. После успешного перевода вы сможете переводить суммы согласно лимитам.',
        success_title: 'Успех',
        success_subtitle: 'Перевод успешно создан',
        sums_dont_add_up: 'Курс валюты обновился. Попробуйте обновить страницу',
        no_such_merchants: 'Нет доступных мерчантов для выполнения перевода. Попробуйте выбрать другой банк или напишите нам в чат',
        network_list: 'Выберите сеть',
        wallet_address_send: 'Адрес кошелька получателя',
        more: 'Подробности',
        profile: 'Профиль',
        days: 'дня',
        hours: 'часов',
        minutes: 'минут',
        seconds: 'секунд',
        description: 'Описание',
        description_text: 'Описание перевода',
        type_card: 'Перевод на карту',
        type_card_desc: 'Вы можете отправить перевод на карту любого банка',
        type_sbp: 'Перевод через СБП',
        type_sbp_desc: 'Вы можете отправить перевод через Систему Быстрых Платежей (СБП)',
        type_stock: 'Перевод через биржу',
        type_stock_desc: '',
        type_wallet: 'Перевод на кошелек',
        type_wallet_desc: 'Вы можете отправить перевод на кошелек',
        type_swift: 'Перевод через SWIFT',
        type_swift_desc: 'Вы можете отправить перевод через SWIFT',
        type_atm: 'Выдача через банкомат',
        type_atm_desc: 'Вы можете получить наличные через банкомат',
        type_office: 'Выдача в офисе',
        type_office_desc: 'Вы можете получить наличные в офисе',
        type_crypto: 'Перевод криптовалюты',
        type_crypto_desc: 'Вы можете отправить перевод в криптовалюте',
        type_delivery: 'Доставка наличных',
        type_delivery_desc: 'Вы можете заказать доставку наличных на дом',
        type_chat: 'Выдача реквизитов в чате',
        type_chat_desc: 'Вы можете получить реквизиты для перевода в чате',
        qr_nspk: 'Оплата по QR',
        qr_nspk_desc: 'Вы можете оплатить по QR через приложение банка',
        crypto_deposit: 'Прием криптовалюты',
        crypto_deposit_desc: 'Вы можете оплатить в USDT сети BEP20 или TRC20',
        crypto_withdraw: 'Вывод в криптовалюту',
        crypto_withdraw_desc: '',
        internal_wallet: 'Внутренний кошелек',
        internal_wallet_topup: 'Вы можете перевести средства на внутренний кошелек',
        internal_wallet_withdraw: 'Вы можете вывести средства с внутреннего кошелька',
        verification_required_title: 'Требуется верификация',
        verification_required_text: 'Чтобы воспользоваться этой платежной системой, пройдите верификацию в профиле.',

        error_title: 'Ошибка',
        err_no_banks: 'Не загружены банки, попробуйте обновить страницу',
        err_no_bank: 'В данный момент нет возможности отправить на этот банк',
        err_payment_systems_loaded: 'Не загружены платежные системы, попробуйте обновить страницу',
        err_payment_system: 'Не найдена платежная система, попробуйте обновить страницу',
        err_enough_deposit: 'Недостаточно средств на депозите для вывода',
        err_no_rates_loaded: 'Не загружены курсы валют, попробуйте обновить страницу',
        err_no_currencies_loaded: 'Не загружены валюты, попробуйте обновить страницу',
        err_no_rate: 'Не найден курс валюты, попробуйте обновить страницу',
        err_bill_dont_exist: 'Такого счета не существует',
        critical_error: 'На данный момент мы оффлайн. Онлайн переводы заработают в 4:00 МСК. Пока вы можете оставить заявку на перевод ниже.',
        no_rates_loaded: 'Не загружены курсы обмена. Попробуйте обновить страницу или напишите нам в чат',
        no_rates_filtered: 'Не найдены курсы обмена. Попробуйте сбросить фильтр',
        err_no_currency_loaded: 'В данный момент нет доступных валют для обмена. Попробуйте обновить страницу или напишите нам в чат',
        no_send_pay_sys: 'Нет доступных платежных систем для отправки перевода. Попробуйте выбрать другой банк или напишите нам в чат',
        err_verification_required: 'Требуется верификация для использования этой платежной системы',
        err_existing_open_transfers: 'У вас есть открытые переводы. Пожалуйста, дождитесь их завершения перед созданием нового перевода.',
        err_test_return: 'Тестовый перевод успешно возвращен',
        err_amounts_not_equal: 'Суммы не совпадают после пересчета. Пожалуйста, попробуйте снова.',
        err_rates_not_equal: 'Курсы не совпадают после пересчета. Пожалуйста, попробуйте снова.',
        err_free_transfer_not_available: 'Бесплатный перевод недоступен в данный момент',
    },
    en: {
        req: 'required',
        until: 'until',
        amount_send: 'Amount and currency',
        currency_send: 'Currency to send',
        currency_receive: 'Currency to receive',
        amount: 'Amount',
        sender_name: 'Sender (you)',
        name_send: `Beneficiary's full name`,
        name_placeholder: `John Wick`,
        phone_send: `Beneficiary's phone number`,
        card_send: `Beneficiary's card number`,
        account_send: `Beneficiary's account number`,
        telegram: 'Telegram nickname',
        telegram_placeholder: '@nickname',
        payment_method: `Choose payment system`,
        choose_senders_bank: 'Choose sender bank',
        choose_recipients_bank: 'Choose recipient bank',
        choose_senders_bank_title: 'You can choose any bank that is convenient for you to send the transfer',
        bank_list: `Choose bank`,
        pay_sys_comission: 'Payment system commission',
        bank_comission: 'Bank commission',
        service_comission: 'Сommission of service',
        use_cashback: 'Use cashback',
        cashback_writeoff: 'Partner wallet write-off',
        guaranteed_rate: 'Guaranteed rate',
        exchange_rate: 'Exchange rate',
        guaranteed_rate_total: 'Total guaranteed rate',
        guaranteed_time: '15 minutes',
        time_title: 'Approximate translation time',
        limits_title: 'Limits for transfer',
        limits_text: 'This rate is not related to the central bank and is calculated based on exchange data.',
        amount_receive: 'Amount and currency to receive',
        select_currency: 'Select currency',
        translation_time: 'Translation time: 15 minutes',
        recipient_list: 'Recipient list',
        choose_recipient: 'Choose recipient',
        create_recipient: 'Create a new recipient',
        select_recipient: 'Choose recipient',
        show_description: 'Show description',
        hide_description: 'Hide description',
        button: 'Create a transfer',
        // Backward compatibility
        button_create: 'Pay the bill',
        button_bill: 'Pay the bill',
        before: 'Pre-registration required',
        first_transfer: 'You have a test transfer for a ',
        do_first_transfer: 'Make a first transfer',
        first_transfer_title: 'What is a test transfer?',
        first_transfer_text: 'For the first time, you can transfer only 500 rubles in order to make sure of the quality of our service. After a successful transfer, you will be able to transfer amounts according to the limits.',
        success_title: 'Success',
        success_subtitle: 'Transfer created successfully',
        sums_dont_add_up: 'The currency exchange rate has been updated. Try to refresh the page',
        no_such_merchants: 'There are no available merchants for the transfer. Try to choose another bank or text us in chat',
        network_list: 'Choose network',
        wallet_address_send: 'Recipient wallet address',
        more: 'More',
        profile: 'Profile',
        days: 'days',
        hours: 'hours',
        minutes: 'minutes',
        seconds: 'seconds',
        description: 'Description',
        description_text: 'Transfer description',
        type_card: 'Transfer to card',
        type_card_desc: 'You can send a transfer to any bank card',
        type_sbp: 'Transfer through the SBP',
        type_sbp_desc: 'You can send a transfer through the Fast Payment System (SBP)',
        type_stock: 'Transfer through the exchange',
        type_stock_desc: '',
        type_wallet: 'Transfer to wallet',
        type_wallet_desc: 'You can send a transfer to a wallet',
        type_swift: 'Transfer via SWIFT',
        type_swift_desc: 'You can send a transfer via SWIFT',
        type_atm: 'Withdrawal through ATM',
        type_atm_desc: 'You can withdraw cash through an ATM',
        type_office: 'Withdrawal at the office',
        type_office_desc: 'You can withdraw cash at the office',
        type_crypto: 'Cryptocurrency transfer',
        type_crypto_desc: 'You can send a transfer in cryptocurrency',
        type_delivery: 'Delivery transfer',
        type_delivery_desc: 'You can order cash delivery to your home',
        type_chat: 'Issuance of details in chat',
        type_chat_desc: 'You can get transfer details in chat',
        qr_nspk: 'QR payment',
        qr_nspk_desc: 'You can pay by QR through the bank application',
        crypto_deposit: 'Cryptocurrency payment',
        crypto_deposit_desc: 'You can pay in USDT BEP20 or TRC20 network',
        crypto_withdraw: 'Cryptocurrency withdrawal',
        crypto_withdraw_desc: '',
        internal_wallet: 'Internal wallet',
        internal_wallet_topup: 'You can transfer funds to an internal wallet',
        internal_wallet_withdraw: 'You can withdraw funds from an internal wallet',
        verification_required_title: 'Verification required',
        verification_required_text: 'Please verify your account to use this payment system.',

        error_title: 'Error',
        err_no_banks: 'Banks not loaded, try to refresh the page',
        err_no_bank: 'There is currently no way to send to this bank',
        err_payment_systems_loaded: 'Payment systems not loaded, try to refresh the page',
        err_payment_system: 'Payment system not found, try to refresh the page',
        err_no_currencies_loaded: 'Currencies not loaded, try to refresh the page',
        err_no_rates_loaded: 'Exchange rates not loaded, try to refresh the page',
        err_no_rate: 'Exchange rate not found, try to refresh the page',
        err_bill_dont_exist: 'This bill does not exist',
        critical_error: 'There are no available merchants for the transfer. Try to refresh the page or come back later. Or text us in chat.',
        no_rates_loaded: 'No exchange rates loaded. Try to refresh the page or text us in chat',
        no_rates_filtered: 'No exchange rates found. Try to reset the filter',
        err_no_currency_loaded: 'There are no available currencies for the exchange. Try to refresh the page or text us in chat',
        no_send_pay_sys: 'There are no available payment systems for the transfer. Try to choose another bank or text us in chat',
        err_enough_deposit: 'Not enough funds in the deposit to withdraw funds',
        err_verification_required: 'Verification is required to use this payment system',
        err_existing_open_transfers: 'You have existing open transfers. Please wait for their completion before creating a new transfer.',
        err_test_return: 'Test transfer successfully returned',
        err_amounts_not_equal: 'Amounts do not match after recalculation. Please try again.',
        err_rates_not_equal: 'Rates do not match after recalculation. Please try again.',
        err_free_transfer_not_available: 'Free transfer is not available at the moment',
    },
};